import React from 'react';
import { ChevronRight } from 'lucide-react';

interface ListItemProps {
  avatar: string; // initials string
  avatarBg?: string; // hex color
  title: string;
  subtitle?: string;
  onClick?: () => void;
  rightElement?: React.ReactNode;
}

export const ListItem: React.FC<ListItemProps> = ({
  avatar,
  avatarBg = '#007AFF',
  title,
  subtitle,
  onClick,
  rightElement,
}) => {
  return (
    <div
      className={`relative h-16 flex items-center pl-[60px] pr-4 ${onClick ? 'cursor-pointer active:opacity-60' : ''}`}
      style={{ borderBottom: '1px solid var(--separator)' }}
      onClick={onClick}
    >
      {/* Avatar */}
      <div
        className="absolute left-4 w-10 h-10 rounded-full flex items-center justify-center"
        style={{ backgroundColor: avatarBg }}
      >
        <span
          className="text-[17px] font-semibold"
          style={{ color: '#FFFFFF' }}
        >
          {avatar}
        </span>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div
          className="text-[17px] font-semibold truncate"
          style={{ color: 'var(--text-primary)' }}
        >
          {title}
        </div>
        {subtitle && (
          <div
            className="text-[15px] truncate"
            style={{ color: 'var(--text-hint)' }}
          >
            {subtitle}
          </div>
        )}
      </div>

      {/* Right element or chevron */}
      <div className="ml-2 flex-shrink-0">
        {rightElement || (
          onClick && (
            <ChevronRight
              size={16}
              style={{ color: 'var(--text-hint)' }}
            />
          )
        )}
      </div>
    </div>
  );
};
